/*
  TMC Bundle: Paket-Auswahl auf der E-Book-Seite und "Upgraden" im Cart Drawer.
  Markup: snippets/tmc-bundle-offer.liquid und snippets/tmc-upsell.liquid (Kontext cart).
  Vanilla, ohne Abhängigkeiten. Nutzt Dawns pubsub (subscribe/publish/PUB_SUB_EVENTS), falls vorhanden.
*/
(function () {
  if (window.tmcBundleReady) return;
  window.tmcBundleReady = true;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  /* ---------- 1. Paket-Auswahl auf der Produktseite ---------- */
  if (!customElements.get('tmc-bundle-offer')) {
    customElements.define(
      'tmc-bundle-offer',
      class TmcBundleOffer extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.handleChange = (event) => {
            if (event.target && event.target.matches && event.target.matches('[data-tmc-offer-input]')) this.apply();
          };
          this.addEventListener('change', this.handleChange);
          /* Zustand nach Zurück-Navigation/Neuaufbau mit dem id-Feld abgleichen */
          this.apply();

          onReady(() => {
            if (!this.isConnected || this.unsubscribe) return;
            if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
          });
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleChange);
          if (this.unsubscribe) this.unsubscribe();
          this.unsubscribe = null;
        }

        get idInput() {
          const form = document.getElementById(this.dataset.form);
          return form ? form.querySelector('input[name="id"]') : null;
        }

        get checkedInput() {
          return this.querySelector('[data-tmc-offer-input]:checked');
        }

        /* Setzt das versteckte id-Feld des Produktformulars auf die gewählte Kachel */
        apply() {
          const checked = this.checkedInput;
          const input = this.idInput;
          const isBundle = Boolean(checked && checked.value === 'bundle');
          this.classList.toggle('is-bundle', isBundle);
          if (!checked || !input) return;
          const id = checked.dataset.variantId;
          if (id && String(input.value) !== String(id)) input.value = id;
        }

        /*
          product-info.js hat nach einem Sprachwechsel das id-Feld bereits auf die neue Sprachvariante gesetzt
          und veröffentlicht danach variantChange mit dem neu gerenderten Abschnitt (data.html).
        */
        onVariantChange(event) {
          const data = event && event.data;
          if (!data || String(data.sectionId) !== String(this.sectionId)) return;

          const html = data.html;
          const fresh = html && html.getElementById ? html.getElementById(this.id) : null;
          if (!fresh) {
            /* Für diese Variante gibt es kein Angebot: auf Kachel A zurück, Dawn hat das id-Feld schon gesetzt */
            const single = this.querySelector('[data-tmc-offer-input][value="single"]');
            if (single) {
              single.checked = true;
              if (data.variant && data.variant.id) single.dataset.variantId = data.variant.id;
            }
            this.hidden = true;
            this.apply();
            return;
          }

          this.hidden = false;
          ['single', 'bundle'].forEach((value) => {
            const current = this.querySelector(`[data-tmc-offer-input][value="${value}"]`);
            const source = fresh.querySelector(`[data-tmc-offer-input][value="${value}"]`);
            if (current && source && source.dataset.variantId) current.dataset.variantId = source.dataset.variantId;
          });
          if (data.variant && data.variant.id) {
            const single = this.querySelector('[data-tmc-offer-input][value="single"]');
            if (single) single.dataset.variantId = data.variant.id;
          }
          this.querySelectorAll('[data-tmc-offer-part]').forEach((part) => {
            const source = fresh.querySelector(`[data-tmc-offer-part="${part.dataset.tmcOfferPart}"]`);
            if (source) part.innerHTML = source.innerHTML;
          });
          this.apply();
        }
      }
    );
  }

  /* ---------- 2. "Upgraden" im Cart Drawer ---------- */
  function readJson(response) {
    return response
      .json()
      .catch(() => ({}))
      .then((data) => {
        if (!response.ok || (data && data.status && data.status >= 400)) throw data || {};
        return data;
      });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(readJson);
  }

  function errorText(error, fallback) {
    if (error && typeof error.description === 'string' && error.description) return error.description;
    if (error && typeof error.message === 'string' && error.message) return error.message;
    return fallback;
  }

  function renderDrawer(drawer, state) {
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      drawer.renderContents(state);
      setTimeout(() => {
        const first = document.querySelector('#CartDrawer .cart-item__name');
        if (first && typeof trapFocus === 'function') trapFocus(drawer, first);
      });
      return true;
    }
    return false;
  }

  function notifyCart(state) {
    /* Nur nötig, wenn zusätzlich die Warenkorbseite (cart-items) offen ist */
    if (!document.querySelector('cart-items')) return;
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tmc-bundle', cartData: state });
  }

  function upgrade(button) {
    const card = button.closest('[data-tmc-upgrade-card]');
    const errorBox = card ? card.querySelector('[data-tmc-upgrade-error]') : null;
    const fallback = button.dataset.error || '';
    const variantId = Number(button.dataset.variantId);
    let keys = [];
    try {
      keys = JSON.parse(button.dataset.removeKeys || '[]');
    } catch (error) {
      keys = [];
    }
    if (!variantId) return;

    const drawer = document.querySelector('cart-drawer');
    const sections =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.id)
        : [];
    const withSections = (body) => {
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      return body;
    };

    const showError = (text) => {
      if (!errorBox) return;
      errorBox.textContent = text || '';
      errorBox.hidden = !text;
    };
    const setBusy = (busy) => {
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
      button.classList.toggle('loading', busy);
      button.disabled = busy;
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    };

    showError('');
    setBusy(true);

    const addUrl = (button.dataset.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    const updateUrl =
      (button.dataset.cartUpdateUrl || (window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';

    /*
      Reihenfolge bewusst: erst das Bundle hinzufügen, dann die Einzelbücher auf 0 setzen.
      Scheitert das Hinzufügen, bleibt der Warenkorb unverändert (keine verlorenen Bücher).
    */
    let added = null;
    postJson(addUrl, withSections({ items: [{ id: variantId, quantity: 1 }] }))
      .then((state) => {
        added = state;
        if (!keys.length) return state;
        const updates = {};
        keys.forEach((key) => {
          updates[key] = 0;
        });
        return postJson(updateUrl, withSections({ updates: updates }));
      })
      .then((state) => {
        if (!renderDrawer(drawer, state)) {
          window.location.reload();
          return;
        }
        notifyCart(state);
      })
      .catch((error) => {
        setBusy(false);
        const text = errorText(error, fallback);
        if (added && renderDrawer(drawer, added)) {
          /* Bundle liegt drin, Einzelbücher nicht entfernt: Drawer zeigt den echten Stand, Fehler darunter */
          setTimeout(() => {
            const cartErrors = document.getElementById('CartDrawer-CartErrors');
            if (cartErrors) cartErrors.textContent = text;
          });
          notifyCart(added);
          return;
        }
        showError(text);
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest ? event.target.closest('[data-tmc-bundle-upgrade]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.hasAttribute('aria-busy')) return;
    upgrade(button);
  });
})();
